(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["images-and-accordions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('images-and-accordions')) {
    const ACTIVE_IMAGE_CLASS = 'is-active';
    const CHANGE_EVENT = 'accordion-group:change';
    const DESKTOP_IMAGE_SELECTOR = '.images-and-accordions__image img';

    class ImagesAndAccordions extends HTMLElement {
      handleGroupChange = (event) => {
        const item = event.detail.item;

        if (!item || !this.contains(item)) {
          return;
        }

        this.showDesktopImage(item.dataset.index);
      };

      connectedCallback() {
        this.abortController = new AbortController();

        this.addEventListener(CHANGE_EVENT, this.handleGroupChange, {
          signal: this.abortController.signal,
        });
      }

      disconnectedCallback() {
        this.abortController.abort();
      }

      showDesktopImage(index) {
        const nextImage = this.querySelector(`${DESKTOP_IMAGE_SELECTOR}[data-index="${index}"]`);

        if (!nextImage || nextImage.classList.contains(ACTIVE_IMAGE_CLASS)) {
          return;
        }

        const desktopImages = this.querySelectorAll(DESKTOP_IMAGE_SELECTOR);

        desktopImages.forEach((image) => {
          image.classList.remove(ACTIVE_IMAGE_CLASS);
        });

        nextImage.classList.add(ACTIVE_IMAGE_CLASS);
      }
    }

    customElements.define('images-and-accordions', ImagesAndAccordions);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  const RECOMMENDATIONS_GRID_SELECTOR = 'content-grid[data-recommendations-url]';
  const RECOMMENDATIONS_BOUND_ATTRIBUTE = 'data-recommendations-bound';
  const PRODUCT_ITEM_SELECTOR = '.product-grid__item:not(.product-grid__item--skeleton)';
  const INTERSECTION_ROOT_MARGIN = '0px 0px 200px 0px';
  const RECENTLY_VIEWED_GRID_SELECTOR = 'content-grid[data-recently-viewed]';
  const RECENTLY_VIEWED_RENDERED_SELECTOR = '[data-recently-viewed-grid]';
  const RECENTLY_VIEWED_STORAGE_KEY = 'recently-viewed-product-handles';
  const CONSENT_TRACKING_API_NAME = 'consent-tracking-api';
  const CONSENT_TRACKING_API_VERSION = '0.1';
  const PRODUCT_ITEM_VIEW = 'item';
  const SLIDER_BUTTON_MINIMUM_ITEMS = 3;

  function bindProductRecommendationGrids(root) {
    const grids = root.querySelectorAll(RECOMMENDATIONS_GRID_SELECTOR);

    grids.forEach((grid) => {
      if (grid.getAttribute(RECOMMENDATIONS_BOUND_ATTRIBUTE) === 'true') {
        return;
      }

      grid.setAttribute(RECOMMENDATIONS_BOUND_ATTRIBUTE, 'true');

      const observer = new IntersectionObserver((entries) => {
        const isVisible = entries.some((entry) => entry.isIntersecting);

        if (!isVisible) {
          return;
        }

        observer.disconnect();
        loadRelatedProductGrid(grid);
      }, { rootMargin: INTERSECTION_ROOT_MARGIN });

      observer.observe(grid);
    });
  }

  function loadRelatedProductGrid(grid) {
    const recommendationsUrl = grid.dataset.recommendationsUrl;

    fetch(recommendationsUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Product recommendations request failed');
        }

        return response.text();
      })
      .then((html) => {
        const responseWrapper = document.createElement('div');
        responseWrapper.innerHTML = html;
        const nextGrid = responseWrapper.querySelector('content-grid');
        const hasProducts = Boolean(nextGrid?.querySelector(PRODUCT_ITEM_SELECTOR));

        if (!hasProducts) {
          hideEmptyProductGrid(grid);
          return;
        }

        grid.replaceWith(nextGrid);
      })
      .catch(() => {
        hideEmptyProductGrid(grid);
      });
  }

  function hideEmptyProductGrid(grid) {
    if (window.Shopify?.designMode) {
      return;
    }

    const section = grid.closest('.shopify-section');

    if (section) {
      section.hidden = true;
      return;
    }

    grid.hidden = true;
  }

  function canUsePreferenceStorage() {
    const customerPrivacy = window.Shopify?.customerPrivacy;

    if (typeof customerPrivacy?.preferencesProcessingAllowed !== 'function') {
      return false;
    }

    return customerPrivacy.preferencesProcessingAllowed();
  }

  function hasDeclinedPreferenceStorage() {
    const customerPrivacy = window.Shopify?.customerPrivacy;

    if (typeof customerPrivacy?.currentVisitorConsent !== 'function') {
      return false;
    }

    return customerPrivacy.currentVisitorConsent().preferences === 'no';
  }

  function clearRecentlyViewedHandles() {
    try {
      window.localStorage.removeItem(RECENTLY_VIEWED_STORAGE_KEY);
    } catch (error) {
      return;
    }
  }

  function readRecentlyViewedHandles() {
    try {
      const storedValue = window.localStorage.getItem(RECENTLY_VIEWED_STORAGE_KEY);
      const parsedHandles = JSON.parse(storedValue || '[]');

      if (!Array.isArray(parsedHandles)) {
        return [];
      }

      return parsedHandles.filter((handle) => typeof handle === 'string' && handle !== '');
    } catch (error) {
      return [];
    }
  }

  function getRecentlyViewedHandles(grid) {
    const currentProductHandle = grid.dataset.currentProductHandle || '';
    const limit = Number(grid.dataset.recentlyViewedLimit);

    return readRecentlyViewedHandles()
      .filter((handle) => handle !== currentProductHandle)
      .slice(0, limit);
  }

  function readProductItemMarkup(html) {
    const responseWrapper = document.createElement('div');
    responseWrapper.innerHTML = html;
    const productItem = responseWrapper.querySelector('product-grid-item');

    if (!productItem) {
      return '';
    }

    return productItem.outerHTML;
  }

  function hideRecentlyViewedGrid(grid) {
    const section = grid.closest('.shopify-section');

    if (section) {
      section.hidden = true;
      return;
    }

    grid.hidden = true;
  }

  function revealRecentlyViewedSkeletons(grid, handleCount) {
    const skeletonItems = Array.from(grid.querySelectorAll('.product-grid__item--skeleton'));
    const sliderButtons = grid.querySelector('.content-grid__slider-buttons');

    skeletonItems.forEach((item, index) => {
      if (index >= handleCount) {
        item.remove();
      }
    });

    if (sliderButtons && handleCount < SLIDER_BUTTON_MINIMUM_ITEMS) {
      sliderButtons.remove();
    }

    showRecentlyViewedGrid(grid);
  }

  function showRecentlyViewedGrid(grid) {
    const section = grid.closest('.shopify-section');

    if (section) {
      section.hidden = false;
    }

    grid.hidden = false;
  }

  function renderRecentlyViewedProducts(grid, productMarkup) {
    const nextGrid = grid.cloneNode(true);
    const itemGrid = nextGrid.querySelector('.content-grid__grid');
    const sliderButtons = nextGrid.querySelector('.content-grid__slider-buttons');

    showRecentlyViewedGrid(nextGrid);
    nextGrid.removeAttribute('aria-busy');
    nextGrid.removeAttribute('data-recently-viewed');
    nextGrid.removeAttribute('data-ready');
    nextGrid.removeAttribute('data-recently-viewed-loaded');

    if (sliderButtons && productMarkup.length < SLIDER_BUTTON_MINIMUM_ITEMS) {
      sliderButtons.remove();
    }

    itemGrid.replaceChildren();

    productMarkup.forEach((markup) => {
      const item = document.createElement('div');
      item.className = 'product-grid__item content-grid__item';
      item.innerHTML = markup;
      itemGrid.append(item);
    });

    grid.replaceWith(nextGrid);
  }

  function loadRecentlyViewedGrid(grid) {
    if (grid.dataset.recentlyViewedLoaded === 'true' || !canUsePreferenceStorage()) {
      return;
    }

    const handles = getRecentlyViewedHandles(grid);

    if (handles.length === 0) {
      hideRecentlyViewedGrid(grid);
      return;
    }

    grid.dataset.recentlyViewedLoaded = 'true';
    revealRecentlyViewedSkeletons(grid, handles.length);

    const productItemUrlBase = grid.dataset.recentlyViewedProductUrlBase;

    const productRequests = handles.map((handle) => {
      const productItemUrl = `${productItemUrlBase}${encodeURIComponent(handle)}?view=${PRODUCT_ITEM_VIEW}`;

      return fetch(productItemUrl)
        .then((response) => {
          if (!response.ok) {
            return '';
          }

          return response.text();
        })
        .then((html) => readProductItemMarkup(html))
        .catch(() => '');
    });

    Promise.all(productRequests).then((itemMarkupList) => {
      const productMarkup = itemMarkupList.filter((markup) => markup !== '');

      if (productMarkup.length === 0) {
        hideRecentlyViewedGrid(grid);
        return;
      }

      renderRecentlyViewedProducts(grid, productMarkup);
    });
  }

  function loadRecentlyViewedWhenAllowed(grid) {
    if (canUsePreferenceStorage()) {
      loadRecentlyViewedGrid(grid);
      return;
    }

    if (typeof window.Shopify?.loadFeatures !== 'function') {
      hideRecentlyViewedGrid(grid);
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: CONSENT_TRACKING_API_NAME, version: CONSENT_TRACKING_API_VERSION }],
      (error) => {
        if (error || !canUsePreferenceStorage()) {
          hideRecentlyViewedGrid(grid);
          return;
        }

        loadRecentlyViewedGrid(grid);
      }
    );
  }

  function bindRecentlyViewedGrids(root) {
    const grids = root.querySelectorAll(RECENTLY_VIEWED_GRID_SELECTOR);

    grids.forEach((grid) => {
      if (grid.dataset.recentlyViewedBound === 'true') {
        return;
      }

      grid.dataset.recentlyViewedBound = 'true';
      loadRecentlyViewedWhenAllowed(grid);
    });
  }

  function bindProductGrids(root) {
    bindProductRecommendationGrids(root);
    bindRecentlyViewedGrids(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      bindProductGrids(document);
    });
  } else {
    bindProductGrids(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    bindProductGrids(event.target);
  });

  document.addEventListener('visitorConsentCollected', () => {
    if (!canUsePreferenceStorage()) {
      if (hasDeclinedPreferenceStorage()) {
        clearRecentlyViewedHandles();
      }

      document.querySelectorAll(RECENTLY_VIEWED_RENDERED_SELECTOR).forEach((grid) => {
        hideRecentlyViewedGrid(grid);
      });
      return;
    }

    document.querySelectorAll(RECENTLY_VIEWED_GRID_SELECTOR).forEach((grid) => {
      loadRecentlyViewedGrid(grid);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
